const feedbackData = [
    {
        id: "1",
        name: "LYan ahmad",
        feed: "Ligasos’s Sales team provided valuable advices and insights. Their excellent local market knowledge, they were always available to answer my questions and provided many options and regular updates throughout the process of choosing our first home.",
        rate: "4"
    },
    {
        id: "2",
        name: "Bushra Alheraki",
        feed: "I was so lucky that I found Ligasos Real Estate Team, they made buying our client’s home in Türkiye an easy experience. They ensured that all paperwork was completed accurately and on time, making the closing process smooth and successful. I highly recommend Ligasos!",
        rate: "5"
    },
    {
        id: "3",
        name: "Nosa Marafi",
        feed: "Ligasos's wealth of experience has a stunning personel service, quick responses to queries and attension to the details. I would highly recommend to any one looking for buying his dream home.",
        rate: "5"
    },
    {
        id: "4",
        name: "Areej Zayed",
        feed: "If you’re looking for an excellent team to guide you through your dream home, look no further than Ligasos. Their excellent reputation and reliability make them a first choice for home-buyers clients.",
        rate: "5"
    },
    {
        id: "5",
        name: "Derayh realestate",
        feed: "A great company gave a full information and details for any client needs",
        rate: "4"
    },
    {
        id: "6",
        name: "Boshra Amer",
        feed: "Highly recommended",
        rate: "5"
    },
    {
        id: "7",
        name: "Sıradışı bir KAYA",
        feed: "It was very beautiful experience for my family.. we were satisfied.. I am definitely offering everybody.",
        rate: "4"
    },
    {
        id: "8",
        name: "Süleyman Altuntaş",
        feed: "As a real estate consultant from Trabzon, I am both a friend and a business partner, the address of safe shopping, and it is a pleasure for us to be friends and do business with you.",
        rate: "5"
    },
]

export default feedbackData;